import React from 'react';
import SubjectPage from '../../subjects/SubjectPage';


function Flashcards() {

  const pageTitleText = "NEET Flashcards for Quick Revision";

  return (
    <>

      <SubjectPage 
        name={pageTitleText} 
        link="flashcards" 
        type="flashcard"
      />

    </>
  );
}

export default Flashcards;